import React from "react";
import myLogo from "../img/my-logo.png";

const Contact = () => {
	return (
		<div className="page-fit flex items-center justify-center">
			<div className="flex flex-col items-center gap-4 h-2/3 sm:w-[70%] md:w-[60%] shadow-lg border p-6">
				<h1 className="text-2xl sm:text-3xl font-bold ">
					Feel free to contact me!
				</h1>
				<img
					className="h-24 w-24 border border-black rounded-full contrast-150"
					src={myLogo}
					alt="myLogo"
				></img>
				<div className="flex gap-12 m-3 text-2xl">
					<i className="cursor-pointer opacity-80 hover:text-orange-600 fa-brands fa-github"></i>
					<i className="cursor-pointer opacity-80 hover:text-orange-600 fa-brands fa-linkedin-in"></i>
					<i className="cursor-pointer opacity-80 hover:text-orange-600 fa-brands fa-instagram"></i>
					<i className="cursor-pointer opacity-80 hover:text-orange-600 fa-brands fa-twitter"></i>
				</div>
			</div>
		</div>
	);
};

export default Contact;
